import React, { useState, ReactNode } from 'react';
import PostsContext from './context';

type PostsContextProviderProps = {
    children: ReactNode;
};

const PostsContextProvider: React.FC<PostsContextProviderProps> = ({ children }) => {
    const [postsCount, setPostsCount] = useState(0);

    return (
        <PostsContext.Provider value={{ postsCount, setPostsCount }}>
            {children}
        </PostsContext.Provider>
    );
};

export default PostsContextProvider;
